import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/filter-1.svg';
import _imports_1 from '@/img/icon/filter-2.svg';
import _imports_2 from '@/img/icon/filter-3.svg';
import _imports_3 from '@/img/icon/close.svg';
import _imports_4 from '@/img/icon/cart-empty.svg';
const _withScopeId = n => (_pushScopeId("data-v-8e0c3088"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "category"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "category__inner"
};
const _hoisted_4 = {
  class: "card"
};
const _hoisted_5 = {
  class: "card__title"
};
const _hoisted_6 = {
  class: "filters"
};
const _hoisted_7 = {
  class: "filters__top"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"filters__top-left\" data-v-8e0c3088><button class=\"filters__top-btn\" data-v-8e0c3088>Все</button><button class=\"filters__top-btn\" data-v-8e0c3088>Классические</button><button class=\"filters__top-btn\" data-v-8e0c3088>Маки</button><button class=\"filters__top-btn\" data-v-8e0c3088>Драконы</button><button class=\"filters__top-btn\" data-v-8e0c3088>Запеченные</button><button class=\"filters__top-btn\" data-v-8e0c3088>Феликсы</button><button class=\"filters__top-btn\" data-v-8e0c3088>Сладкие</button></div>", 1);
const _hoisted_9 = {
  class: "filters__bottom"
};
const _hoisted_10 = {
  class: "filters__bottom-left"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filters__bottom-imgwrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon"
})], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filters__bottom-imgwrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon"
})], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filters__bottom-imgwrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icon"
})], -1));
const _hoisted_14 = {
  class: "filters__bottom-right"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_20 = {
  key: 0,
  class: "filters__category-count"
};
const _hoisted_21 = {
  class: "ingredients__top"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "ingredients__title"
}, "Инградиенты", -1));
const _hoisted_23 = {
  class: "ingredients__top-right"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "close"
}, null, -1));
const _hoisted_25 = [_hoisted_24];
const _hoisted_26 = {
  class: "ingredients__list"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["src", "alt"];
const _hoisted_29 = {
  key: 0,
  class: "category-empty"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "category-empty__img",
  src: _imports_4,
  alt: "empty"
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-empty__box"
}, [/*#__PURE__*/_createElementVNode("h5", {
  class: "category-empty__title"
}, "Ничего не найдено"), /*#__PURE__*/_createElementVNode("p", {
  class: "category-empty__text"
}, " Попробуйте найти в другой категории или измените параметры поиска товаров в этой категории ")], -1));
const _hoisted_32 = [_hoisted_30, _hoisted_31];
const _hoisted_33 = {
  key: 1,
  class: "loader-box"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "loader"
}, null, -1));
const _hoisted_35 = [_hoisted_34];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Category = _resolveComponent("Category");
  const _component_Crumbs = _resolveComponent("Crumbs");
  const _component_app_select = _resolveComponent("app-select");
  const _component_app_dialog = _resolveComponent("app-dialog");
  const _component_CategoryList = _resolveComponent("CategoryList");
  const _component_InfoText = _resolveComponent("InfoText");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Category, {
    class: "category-pages"
  }), _createVNode(_component_Crumbs, {
    paths: $options.paths,
    class: "crumbs"
  }, null, 8, ["paths"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, _toDisplayString(this.categoryMap[this.category]), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_app_select, {
    modelValue: $data.filters.selectSort,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filters.selectSort = $event),
    options: $data.sortOptions
  }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    class: _normalizeClass(["filters__bottom-btn", {
      'filters--checked': $data.filters.filter_1
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $data.filters.filter_1 = !$data.filters.filter_1)
  }, [_hoisted_11, _createTextVNode(" Острые ")], 2), _createElementVNode("button", {
    class: _normalizeClass(["filters__bottom-btn", {
      'filters--checked': $data.filters.filter_2
    }]),
    onClick: _cache[2] || (_cache[2] = $event => $data.filters.filter_2 = !$data.filters.filter_2)
  }, [_hoisted_12, _createTextVNode(" Вегетарианские ")], 2), _createElementVNode("button", {
    class: _normalizeClass(["filters__bottom-btn", {
      'filters--checked': $data.filters.filter_3
    }]),
    onClick: _cache[3] || (_cache[3] = $event => $data.filters.filter_3 = !$data.filters.filter_3)
  }, [_hoisted_13, _createTextVNode(" Безлактозные ")], 2)]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ingredients.slice(0, 4), (item, id) => {
    return _openBlock(), _createElementBlock("button", {
      key: id,
      onClick: $event => $data.filters['ingredients_' + item.id] = !$data.filters['ingredients_' + item.id],
      class: _normalizeClass(["ingredients-btn", {
        'ingredients--checked': $data.filters['ingredients_' + item.id]
      }]),
      style: _normalizeStyle({
        '--color': item.color
      })
    }, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: item.name
    }, null, 8, _hoisted_16), _createElementVNode("p", null, _toDisplayString(item.name), 1)], 14, _hoisted_15);
  }), 128)), _createElementVNode("button", {
    class: "filters__category-burger",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.showDialog && $options.showDialog(...args))
  }, [_hoisted_17, _hoisted_18, _hoisted_19, $options.countIngredients > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString($options.countIngredients), 1)) : _createCommentVNode("", true)]), _createVNode(_component_app_dialog, {
    show: $data.dialogVisible,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.dialogVisible = $event),
    class: "ingredients"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("button", {
      class: "ingredients-reset",
      onClick: _cache[5] || (_cache[5] = (...args) => $options.resetIngredients && $options.resetIngredients(...args))
    }, " Сбросить все "), _createElementVNode("button", {
      class: "ingredients-close",
      onClick: _cache[6] || (_cache[6] = (...args) => $options.hideDialog && $options.hideDialog(...args))
    }, _hoisted_25)])]), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ingredients, (item, id) => {
      return _openBlock(), _createElementBlock("button", {
        key: id,
        onClick: $event => $data.filters['ingredients_' + item.id] = !$data.filters['ingredients_' + item.id],
        class: _normalizeClass(["ingredients-btn", {
          'ingredients--checked': $data.filters['ingredients_' + item.id]
        }]),
        style: _normalizeStyle({
          '--color': item.color
        })
      }, [_createElementVNode("img", {
        src: item.imgUrl,
        alt: item.name
      }, null, 8, _hoisted_28), _createElementVNode("p", null, _toDisplayString(item.name), 1)], 14, _hoisted_27);
    }), 128))])]),
    _: 1
  }, 8, ["show"])])])]), _createVNode(_component_CategoryList, {
    items: $setup.categores,
    onAddToFavorite: _cache[8] || (_cache[8] = item => this.addToFavorite(item)),
    onAddToCart: _cache[9] || (_cache[9] = item => $setup.onClickAddPlus(item)),
    onLoadMoreCategory: _cache[10] || (_cache[10] = $event => !$data.isAllLoading ? $options.loadMoreCategory() : $options.load()),
    check: $data.isAllLoading,
    total: $data.total
  }, null, 8, ["items", "check", "total"]), $setup.categores.length == 0 && $data.isLoading === false ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32)) : _createCommentVNode("", true), $data.isLoading === true && $setup.categores.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35)) : _createCommentVNode("", true), _createVNode(_component_InfoText)])])])]);
}